export default __webpack_public_path__ + "static/media/background_shake-jack.75e215a9.png";